var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAuditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 80,
    viewBox: "0 0 71 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.6594 48.6138C25.9134 48.6138 23.5427 47.7195 21.5471 45.931L23.7263 43.3201C25.3706 44.6775 27.039 45.3562 28.7312 45.3562C29.4816 45.3562 30.0723 45.2124 30.5033 44.925C30.9344 44.6376 31.1499 44.2383 31.1499 43.7273C31.1499 43.2483 30.9264 42.865 30.4794 42.5776C30.0324 42.2742 29.1304 41.9468 27.7733 41.5955C26.8155 41.356 26.0412 41.1244 25.4505 40.9009C24.8598 40.6613 24.293 40.3499 23.7502 39.9667C23.2234 39.5834 22.8322 39.1044 22.5768 38.5295C22.3373 37.9387 22.2176 37.236 22.2176 36.4216C22.2176 34.9046 22.7604 33.683 23.846 32.7568C24.9476 31.8306 26.3605 31.3675 28.0847 31.3675C30.4634 31.3675 32.5389 32.0781 34.311 33.4993L32.3952 36.2779C30.8147 35.176 29.3619 34.6251 28.0368 34.6251C27.3503 34.6251 26.8155 34.7688 26.4323 35.0563C26.0651 35.3278 25.8815 35.687 25.8815 36.1342C25.8815 36.6771 26.113 37.0843 26.576 37.3558C27.039 37.6273 28.0128 37.9546 29.4976 38.3379C31.3175 38.8169 32.6586 39.4317 33.5207 40.1823C34.3828 40.9328 34.8139 42.0107 34.8139 43.416C34.8139 45.0448 34.2471 46.3223 33.1136 47.2485C31.9961 48.1587 30.5113 48.6138 28.6594 48.6138Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.0144 48.3743V31.607H50.7783V34.9605H41.7023V38.5295H49.7007V41.8829H41.7023V48.3743H38.0144Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9117 22.5497H0L12.9091 45.0994L25.9117 22.5497Z",
    fill: "url(#paint0_linear_2201_37208)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9091 0L0 22.5497H25.9117L12.9091 0Z",
    fill: "url(#paint1_linear_2201_37208)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9091 0L25.9117 22.5497L38.9144 0H12.9091Z",
    fill: "url(#paint2_linear_2201_37208)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9117 22.5497H51.8235L38.9144 0L25.9117 22.5497Z",
    fill: "url(#paint3_linear_2201_37208)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M71 57.6374L57.9974 34.9006L45.135 57.6374H71Z",
    fill: "url(#paint4_linear_2201_37208)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M45.135 57.6374L32.0856 80H57.9974L45.135 57.6374Z",
    fill: "url(#paint5_linear_2201_37208)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2701 57.6374L32.0856 80L45.135 57.6374H19.2701Z",
    fill: "url(#paint6_linear_2201_37208)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M71 57.6374H45.135L57.9974 80L71 57.6374Z",
    fill: "url(#paint7_linear_2201_37208)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2201_37208",
    x1: 12.6285,
    y1: 23.1111,
    x2: 12.6285,
    y2: 44.6316,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9426F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FC871A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2201_37208",
    x1: 12.8155,
    y1: 22.5497,
    x2: 12.8155,
    y2: -0.00000138071,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#33BEFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4E7DFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2201_37208",
    x1: 38.8208,
    y1: 0,
    x2: 13.9381,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9426F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FC871A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2201_37208",
    x1: 26.0053,
    y1: 22.3626,
    x2: 52.1976,
    y2: 22.3626,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#33BEFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4E7DFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2201_37208",
    x1: 59.4005,
    y1: 57.2632,
    x2: 58.0903,
    y2: 35.9299,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9426F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FC871A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2201_37208",
    x1: 37.4177,
    y1: 69.8947,
    x2: 51.917,
    y2: 69.8947,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9426F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FC871A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2201_37208",
    x1: 45.9302,
    y1: 57.6374,
    x2: 19.7378,
    y2: 58.0115,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#33BEFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4E7DFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_2201_37208",
    x1: 58.7457,
    y1: 57.4503,
    x2: 57.997,
    y2: 80.0936,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#33BEFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4E7DFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuditIcon);
export default __webpack_public_path__ + "static/media/audit-icon.a41b8c77181345385c0a194253c51473.svg";
export { ForwardRef as ReactComponent };